import { render, staticRenderFns } from "./GlassBreakageDamageTypeQuestion.vue?vue&type=template&id=f38d588e&scoped=true"
import script from "./GlassBreakageDamageTypeQuestion.vue?vue&type=script&lang=ts"
export * from "./GlassBreakageDamageTypeQuestion.vue?vue&type=script&lang=ts"
import style0 from "./GlassBreakageDamageTypeQuestion.vue?vue&type=style&index=0&id=f38d588e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f38d588e",
  null
  
)

export default component.exports